import { Injectable } from '@angular/core';
import { Md5 } from 'ts-md5';

import { InfoApiService } from './info-api.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class KeyGeneratorService {

  constructor(
    private readonly userApi: UserService,
    private readonly infoApi: InfoApiService,
  ) {
  }

  getBinaryKeyGenerator() {
    const token = this.userApi.selectStateSnasphot().token;
    const info = this.infoApi.selectStateSnapshot().info;
    const ipAddress = info && info.ip_address;

    const key = `${token}${ipAddress}`;
    const keyHashed = Md5.hashStr(key) as string;
    return keyHashed;
  }
}
